import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import Constants from '@/plugins/constants';
import Vue from 'vue';
const connection = new HubConnectionBuilder()
  .withUrl(Constants.HUBURL + '/notificationHub', {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  })
  .configureLogging(LogLevel.None)
  .build();
const notificationHub = new Vue();
Vue.prototype.$notificationHub = notificationHub;
// function start() {
//   try {
//     connection
//       .start()
//       .then(() => {
//       })

//   } catch (err) {
//     // setTimeout(start, 5000);
//   }
// }
// connection.onclose(start);
// start();
connection.on('Ringing', (RingingModel) => {
  notificationHub.$emit('Ringing', { RingingModel });
});
connection.on('Up', (upModel) => {
  notificationHub.$emit('Up', { upModel });
});
connection.on('HangUp', (hangUpModel) => {
  notificationHub.$emit('HangUp', { hangUpModel });
});
connection.on('Signal', function () {
  notificationHub.$emit('Signal');
});
connection.on('MainList115', function () {
  const is115MissionRoute = window.location.pathname.includes('/115/mission');
  if (is115MissionRoute) notificationHub.$emit('MainList115');
});
connection.on('MainList800', function () {
  // console.log("BBBB 11 : ", "MainList800");
  const is800MissionRoute = window.location.pathname.includes('/800/mission');
  const is800MissionRoute2 = window.location.pathname.includes('/800/currentMission800');
  if (is800MissionRoute || is800MissionRoute2) notificationHub.$emit('MainList800');
});
connection.on('TopList800', function () {
  // console.log("BBBB 11 : ", "TopList800");
  const is800MissionRoute = window.location.pathname.includes('/800/mission');
  const is800MissionRoute2 = window.location.pathname.includes('/800/newMissionWithMap800');
  if (is800MissionRoute || is800MissionRoute2) notificationHub.$emit('TopList800');
});

connection.on('MainListAdmission', function () {
  notificationHub.$emit('MainListAdmission');
});
connection.on('MainListDoctor', function () {
  const isdoctorMissionRoute = window.location.pathname.includes('/doctor/missions');
  if (isdoctorMissionRoute) notificationHub.$emit('MainListDoctor');
});
connection.on('MainListFollowUp', function () {
  notificationHub.$emit('MainListFollowUp');
});
connection.on('NewMission800', function () {
  notificationHub.$emit('NewMission800');
});
connection.on('HospitalList', function () {
  notificationHub.$emit('HospitalList');
});
connection.on('OutOfServiceCodes', function () {
  notificationHub.$emit('OutOfServiceCodes');
});
connection.on('WaitInHospitalList', function () {
  notificationHub.$emit('WaitInHospitalList');
});
connection.on('OutOfServiceHospital', function () {
  notificationHub.$emit('OutOfServiceHospital');
});
connection.on('CodeListFollowUp', function () {
  notificationHub.$emit('CodeListFollowUp');
});
connection.on('HospitalMainList', function () {
  notificationHub.$emit('HospitalMainList');
});
connection.on('DispatchNotification', function () {
  // console.log('DispatchNotification');
  // notificationHub.$emit("DispatchNotification",data);
});
connection.on('Termine', function () {
  notificationHub.$emit('Termine');
});
connection.on('Location', (data) => {
  notificationHub.$emit('Location', { data });
});
export default {
  connection,
};
/*export default {
    install(Vue) {
        const connection = new HubConnectionBuilder()
            .withUrl(Constants.HUBURL + "/notificationHub", {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                withCredentials: true,
            })
            .configureLogging(LogLevel.None)
            .build();
        const notificationHub = new Vue()
        Vue.prototype.$notificationHub = notificationHub;
        function start() {
            try {
                connection.start().then(() => {
                    console.log("connect");
                }).catch(e => {
                    console.log("err", e);
                    setTimeout(start, 5000)
                })
            } catch (err) {
                console.log("err", err);
                setTimeout(start, 5000)
            }
        }
        connection.onclose(start);
        start();
        connection.on('Ringing', (RingingModel) => {
            notificationHub.$emit('Ringing', { RingingModel })
        })
        connection.on('Up', (upModel) => {
            notificationHub.$emit('Up', { upModel })
        })
        connection.on('Signal', function () {
            notificationHub.$emit('Signal')
        })
        connection.on('MainList115', function () {
            notificationHub.$emit('MainList115')
        })
        connection.on('MainList800', function () {
            notificationHub.$emit('MainList800')
        })
        connection.on('TopList800', function () {
            notificationHub.$emit('TopList800')
        })
        connection.on('MainListAdmission', function () {
            notificationHub.$emit('MainListAdmission')
        })
        connection.on('MainListDoctor', function () {
            notificationHub.$emit('MainListDoctor')
        })
        connection.on('MainListFollowUp', function () {
            notificationHub.$emit('MainListFollowUp')
        })
        connection.on('NewMission800', function () {
            notificationHub.$emit('NewMission800')
        })
        connection.on('HospitalList', function () {
            notificationHub.$emit('HospitalList')
        })
        connection.on('OutOfServiceCodes', function () {
            notificationHub.$emit('OutOfServiceCodes')
        })
        connection.on('WaitInHospitalList', function () {
            notificationHub.$emit('WaitInHospitalList')
        })
        connection.on('OutOfServiceHospital', function () {
            notificationHub.$emit('OutOfServiceHospital')
        })
        connection.on('CodeListFollowUp', function () {
            notificationHub.$emit('CodeListFollowUp')
        })
        connection.on('HospitalMainList', function () {
            notificationHub.$emit('HospitalMainList')
        })
    }
}*/
